import React from "react";

// アイテム/グループ選択(タブバー)の対象になるセクション群。
// 副資材(113-117)と品質表示(118-124)はそれぞれ独立した選択スコープを持つ。
// 登録グループ(125)はアイテム選択で内容が切り替わらないため対象外。
const ITEM_GROUP_SCOPES = [
    {
        domain: "fukushizai",
        ids: ["fukushizai", "komonofuda", "brandname", "othername", "other_fukushizai"]
    },
    {
        domain: "quality",
        ids: ["hinshitsu", "sosei", "hoteigai", "fukiyogo", "koseibuhin", "demerit", "sentakuhyoji"]
    }
];

function findItemGroupScope(sectionId) {
    return ITEM_GROUP_SCOPES.find((scope) => scope.ids.includes(sectionId)) || null;
}

// セクション一覧と上部チップ一覧の表示モデルをまとめて返します。
export function buildSectionListPresentation({
    kakouShijiKubun,
    currentSampleSectionDefs,
    currentNormalSectionDefs,
    orderSectionsByPanel,
    showSections,
    sectionChipLabelMap,
    renderSection,
    renderItemGroupTabBar,
    renderItemGroupScopeHeader,
    isEmpty
}) {
    const sections = typeof showSections === "function" ? showSections() : [];

    // 上部チップは type1 基準の固定順で並べます。
    const chipSource = orderSectionsByPanel(
        kakouShijiKubun === "sample"
            ? currentSampleSectionDefs()
            : currentNormalSectionDefs().filter((section) => section.view === "type1")
    );

    // s_logp 由来の全セクションをチップ化する(品番マスタと同じ挙動)。
    // 以前は sectionChipTargetIds のホワイトリストで主要セクションのみに絞っていた。
    const topSectionChips = chipSource
        .filter((section) => !isEmpty(section))
        .map((section) => ({
            id: section.id,
            label: sectionChipLabelMap[section.id] || section.label
        }));

    // 副資材(113-117)/品質表示(118-124)の各連続区間を枠線ラッパーで包み、
    // それぞれの先頭にドメイン別のアイテムタブ+グループトグルを挿入します。
    const renderedSections = [];
    if (Array.isArray(sections)) {
        let scopeBuffer = [];
        let scopeFirstSection = null;
        let currentScope = null;
        const flushScope = () => {
            if (scopeBuffer.length === 0) return;
            const domain = currentScope?.domain || "fukushizai";
            renderedSections.push(
                <div key={"kakousiji-itemgroup-scope-" + domain} className="kakousiji-itemgroup-scope">
                    {typeof renderItemGroupScopeHeader === "function" ? renderItemGroupScopeHeader(domain) : null}
                    {typeof renderItemGroupTabBar === "function" ? renderItemGroupTabBar(scopeFirstSection, domain) : null}
                    {scopeBuffer}
                </div>
            );
            scopeBuffer = [];
            scopeFirstSection = null;
            currentScope = null;
        };
        sections.forEach((section) => {
            const scope = findItemGroupScope(section.id);
            if (scope !== null) {
                // 別スコープへ移ったら先に前スコープを確定する。
                if (currentScope !== null && currentScope.domain !== scope.domain) flushScope();
                if (scopeFirstSection === null) scopeFirstSection = section;
                currentScope = scope;
                scopeBuffer.push(renderSection(section));
                return;
            }
            flushScope();
            renderedSections.push(renderSection(section));
        });
        flushScope();
    }

    return {
        sections,
        topSectionChips,
        renderedSections
    };
}
